import { Component, HostBinding } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { HooksWireup, OnRouteResolve } from '@frontend/sports/common/core/utils/hooks';
import { LiveUrlParam } from '@frontend/sports/navigation/core/feature/url-helper';

import { TabBarItem } from '../tab-bar/tab-bar.models';
import { LiveEventListService, LiveSportListModel } from './live-event-list.service';

@HooksWireup()
@Component({
    selector: 'ms-live-sport-list',
    standalone: false,
    templateUrl: 'live-sport-list.component.html',
})
export class LiveSportListComponent extends OnRouteResolve<LiveSportListModel> {
    @HostBinding('class') className = 'live-sport-list';

    sports: TabBarItem[];

    constructor(
        public sitecore: Sitecore,
        private liveEventListService: LiveEventListService,
        route: ActivatedRoute,
    ) {
        super(route);
    }

    onRouteResolved(model: LiveSportListModel): void {
        if (!model) {
            return;
        }

        this.sports = this.liveEventListService
            .getSportTabs(model.sports, model.videoEventCount, LiveUrlParam.SportList)
            .filter(this.sportsFilter)
            .sort(this.sportsComparer);
    }

    private sportsFilter = (sport: TabBarItem): boolean =>
        sport.id !== LiveUrlParam.Highlights &&
        sport.id !== LiveUrlParam.SportList &&
        sport.id !== LiveUrlParam.Favourites &&
        sport.id !== LiveUrlParam.LiveCasino;

    private sportsComparer = (first: TabBarItem, second: TabBarItem): number => {
        if (first.id === LiveUrlParam.Video) {
            return -1;
        } else if (second.id === LiveUrlParam.Video) {
            return 1;
        } else if (first.title! < second.title!) {
            return -1;
        } else if (first.title! > second.title!) {
            return 1;
        } else {
            return 0;
        }
    };
}
